module.exports = __webpack_public_path__ + "static/media/trial-alert.2dcc8e50.svg";